import { render, staticRenderFns } from "./Videos.vue?vue&type=template&id=d9843ff2&scoped=true"
import script from "./Videos.vue?vue&type=script&lang=js"
export * from "./Videos.vue?vue&type=script&lang=js"
import style0 from "./Videos.vue?vue&type=style&index=0&id=d9843ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9843ff2",
  null
  
)

/* custom blocks */
import block0 from "./Videos.vue?vue&type=custom&index=0&blockType=title"
if (typeof block0 === 'function') block0(component)
import block1 from "./Videos.vue?vue&type=custom&index=1&blockType=layout"
if (typeof block1 === 'function') block1(component)

export default component.exports